import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {Button} from '@material-ui/core';
import AdminReadingTable from './AdminReadingTable';
import AdminReadingForm from './AdminReadingForm';
import MessageForm from '../User/MessageForm';
import {Modal} from '../common';
import {
  fetchAdminReadings,
  setCurrentAdminReadingPage,
  setCurrentAdminReading,
  clearAdminReadingsAfterPage,
} from 'actions/readings';
import {deleteReadingComment, deleteReading} from 'api/readings';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';
import {isKluwellAdmin} from 'utils/permissions';

class AdminReadingList extends React.Component {
  static propTypes = {
    adminReadingPages: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {
      refreshTableKey: 0,
      currentReading: null,
      modalShown: false,
      recordToUpdate: false,
      messageModalShown: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.deleteReadingComment = this.deleteReadingComment.bind(this);
    this.openSendMessageModal = this.openSendMessageModal.bind(this);
    this.closeSendMessageModal = this.closeSendMessageModal.bind(this);
  }

  showModal(recordToUpdate) {
    this.setState({
      modalShown: true,
      recordToUpdate,
    });
  }

  closeModal() {
    this.setState({
      modalShown: false,
      recordToUpdate: null,
    });
  }

  handleSuccess() {
    this.setState((prevState) => ({
      modalShown: false,
      recordToUpdate: null,
      refreshTableKey: prevState.refreshTableKey + 1,
    }));
  }

  deleteReadingComment(reading, deleteComment) {
    const {addFlashMessage, formatErrors} = this.props;
    return (deleteComment ? deleteReadingComment : deleteReading)(reading.id)
      .then(() => {
        this.setState((prevState) => ({
          refreshTableKey: prevState.refreshTableKey + 1,
        }));
        console.log(1);
        addFlashMessage(
          'The reading ' + (deleteComment ? 'comment' : '') + ' has been successfully deleted!',
          'success',
        );
      })
      .catch((err) => formatErrors(err));
  }

  openSendMessageModal(currentReading) {
    this.setState({
      currentReading,
      messageModalShown: true,
    });
  }

  closeSendMessageModal() {
    this.setState({
      currentReading: null,
      messageModalShown: false,
    });
  }

  render() {
    const {modalShown, recordToUpdate, refreshTableKey, currentReading, messageModalShown} = this.state;
    const {
      user,
      adminReadingPages,
      fetchAdminReadings,
      setCurrentAdminReadingPage,
      setCurrentAdminReading,
      clearAdminReadingsAfterPage,
    } = this.props;
    return (
      <React.Fragment>
        <Modal
          title="Send a message"
          onClose={this.closeSendMessageModal}
          open={messageModalShown}
          renderContent={() => (
            <MessageForm
              receiver={currentReading.reader}
              reading={currentReading}
              onSubmitSuccess={this.closeSendMessageModal}
            />
          )}
        />
        <Modal
          title={recordToUpdate ? 'Edit Reading' : 'Create New Reading'}
          onClose={this.closeModal}
          open={modalShown}
          renderContent={() => <AdminReadingForm initialValues={recordToUpdate} onSubmitSuccess={this.handleSuccess} />}
        />
        <div className="container content-box">
          <Panel>
            <h3 className="section-header">
              <div className="section-title">Readings</div>
              <Button variant="contained" color="primary" className="pull-right" onClick={() => this.showModal()}>
                Create Reading
              </Button>
            </h3>
            <AdminReadingTable
              {...{
                key: refreshTableKey,
                recordPages: adminReadingPages,
                fetchRecords: fetchAdminReadings,
                setCurrentRecordPage: setCurrentAdminReadingPage,
                setCurrentRecord: setCurrentAdminReading,
                clearRecordsAfterPage: clearAdminReadingsAfterPage,
                showUpdateModal: this.showModal,
                onDeleteActionClick: this.deleteReadingComment,
                hiddenFields: isKluwellAdmin(user.role) ? [] : ['readerSchool'],
                openSendMessageModal: this.openSendMessageModal,
              }}
            />
          </Panel>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    user: state.account.get('user').toJS(),
    adminReadingPages: state.readings.get('adminReadingPages').toJS(),
  }),
  {
    formatErrors,
    addFlashMessage,
    fetchAdminReadings,
    setCurrentAdminReadingPage,
    setCurrentAdminReading,
    clearAdminReadingsAfterPage,
  },
)(AdminReadingList);
